/**
 * @generated SignedSource<<14eebe1ffea7bb232ffe52ee7d376b24>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type MATPremiumTypeEnum = "premium_non_refundable" | "premium_refundable" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type UserInvoiceConnectionDataTable_UserInvoiceConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly id: string;
      readonly order: {
        readonly amount: number;
        readonly applyEndDate: any;
        readonly applyStartDate: any;
        readonly paidAt: any;
      };
      readonly product: {
        readonly item: {
          readonly premiumType: MATPremiumTypeEnum;
        };
        readonly name: string;
      };
    };
  }>;
  readonly " $fragmentType": "UserInvoiceConnectionDataTable_UserInvoiceConnection";
};
export type UserInvoiceConnectionDataTable_UserInvoiceConnection$key = {
  readonly " $data"?: UserInvoiceConnectionDataTable_UserInvoiceConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserInvoiceConnectionDataTable_UserInvoiceConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserInvoiceConnectionDataTable_UserInvoiceConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MATUserInvoiceEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MATUserInvoice",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "MATInternalProduct",
              "kind": "LinkedField",
              "name": "product",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "MATInternalItem",
                  "kind": "LinkedField",
                  "name": "item",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "premiumType",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "MATInternalOrder",
              "kind": "LinkedField",
              "name": "order",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "paidAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "amount",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "applyStartDate",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "applyEndDate",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MATUserInvoiceConnection",
  "abstractKey": null
};

(node as any).hash = "6464f202f99e1f4cfa9278b2215a379a";

export default node;
